import type { MapLink } from './statusTelemetryApi';

// This adapter accepts only a tenant-configured link projection. Device inventory
// and alert resources deliberately cannot create arcs through this boundary.
export const toLegacyMapLinkInput = (link: MapLink) => ({
  id: link.id,
  source: link.source.location,
  target: link.target.location,
  status: link.state.health,
  status_reason: link.state.status_reason,
  missing_telemetry: link.state.missing_metrics?.length
    ? { source: link.state.missing_metrics, target: link.state.missing_metrics }
    : undefined,
  bandwidth_mbps: Math.max(1, (link.capacity_bps ?? 1_000_000) / 1_000_000),
  updated_at: link.state.observed_at || link.updated_at,
  source_device_id: link.source.device_id,
  target_device_id: link.target.device_id,
  source_interface_id: link.source.interface_id,
  target_interface_id: link.target.interface_id,
  link_type: link.link_type,
  topology_status: link.topology_status,
  topology_reason: link.topology_reason,
  topology_confidence: link.topology_confidence,
  topology_evidence_types: link.topology_evidence_types,
  ingress_utilization_pct: link.state.ingress_utilization_pct,
  egress_utilization_pct: link.state.egress_utilization_pct,
  telemetry_host_a: link.source.device_host,
  telemetry_host_b: link.target.device_host,
  telemetry_ifindex_a: link.source.interface_ifindex,
  telemetry_ifindex_b: link.target.interface_ifindex,
  telemetry_ifname_a: link.source.interface_name,
  telemetry_ifname_b: link.target.interface_name
});
